import { Box, Skeleton, useToast } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';
import ReactDiffViewer from 'react-diff-viewer';

import {
  errorToastAdminConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { useGetCreditAgreementFullArtifactQuery } from 'packages/creditAgreements/requests/requests.gql.generated';
import { getCreditAgreementFullArtifactLabel } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';

type CreditAgreementDiffProps = {
  creditAgreementId1: string;
  creditAgreementId2: string;
};
export const CreditAgreementDiff = ({
  creditAgreementId1,
  creditAgreementId2,
}: CreditAgreementDiffProps) => {
  const toast = useToast();

  const {
    loading: loading1,
    data: creditAgreementFullArtifact1Data,
  } = useGetCreditAgreementFullArtifactQuery({
    variables: {
      creditAgreementId: creditAgreementId1,
    },
    onError: () => {
      if (!toast.isActive(errorToastId)) {
        errorToastAdminConfig.title = `Error loading credit agreement.`;
        toast(errorToastAdminConfig);
      }
    },
    fetchPolicy: 'network-only',
  });

  const {
    loading: loading2,
    data: creditAgreementFullArtifact2Data,
  } = useGetCreditAgreementFullArtifactQuery({
    variables: {
      creditAgreementId: creditAgreementId2,
    },
    onError: () => {
      if (!toast.isActive(errorToastId)) {
        errorToastAdminConfig.title = `Error loading credit agreement.`;
        toast(errorToastAdminConfig);
      }
    },
    fetchPolicy: 'network-only',
  });

  const loading = loading1 || loading2;
  if (
    loading ||
    !creditAgreementFullArtifact1Data ||
    !creditAgreementFullArtifact2Data
  ) {
    return <Skeleton />;
  }

  const {
    creditAgreementFullArtifact: { creditAgreement: creditAgreement1 },
  } = creditAgreementFullArtifact1Data;
  const {
    creditAgreementFullArtifact: { creditAgreement: creditAgreement2 },
  } = creditAgreementFullArtifact2Data;
  try {
    const creditAgreementObj1 = JSON.parse(creditAgreement1);
    const creditAgreementObj2 = JSON.parse(creditAgreement2);
    const [oldCAObj, newCaObj] = _.sortBy(
      [creditAgreementObj1, creditAgreementObj2],
      (caObj) => caObj.effectiveFrom,
    );

    return (
      <Box mt="35px" mb="35px">
        <ReactDiffViewer
          oldValue={JSON.stringify(oldCAObj, null, 4)}
          newValue={JSON.stringify(newCaObj, null, 4)}
          leftTitle={getCreditAgreementFullArtifactLabel(oldCAObj)}
          rightTitle={getCreditAgreementFullArtifactLabel(newCaObj)}
          splitView
          useDarkTheme
        />
      </Box>
    );
  } catch (err) {
    errorToastAdminConfig.title = `Error parsing credit agreement artifact for credit agreement ${creditAgreementId1}`;
    toast(errorToastAdminConfig);
  }

  throw new Error('unreachable code here');
};

export default CreditAgreementDiff;
